"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useTheme = require("../styles/useTheme");
var _withWidth = _interopRequireWildcard(require("../withWidth"));
var _HiddenProps = require("./HiddenProps");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// @ts-ignore FIXME hardcore typing error on HiddenJs
const HiddenJs = props => {
  const {
    children,
    only,
    width
  } = props;
  const theme = (0, _useTheme.useTheme)();
  let visible = true;

  // `only` check is faster to get out sooner if used.
  if (only) {
    if (Array.isArray(only)) {
      for (const breakpoint of only) {
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }

  // Allow `only` to be combined with other props. If already hidden, no need to check others.
  if (visible && width) {
    // determine visibility based on the smallest size up
    for (const breakpoint of theme.busbud.breakpoints.keys) {
      const breakpointUp = props[(0, _HiddenProps.getBreakpointUpKey)(breakpoint)];
      const breakpointDown = props[(0, _HiddenProps.getBreakpointDownKey)(breakpoint)];
      if (breakpointUp && (0, _withWidth.isWidthUp)(breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }
  if (!visible) {
    return null;
  }
  return children;
};
var _default = exports.default = (0, _withWidth.default)()(HiddenJs);